import React, { Component } from 'react';
import { Breadcrumb, Tabs, Button, Form, Input, Radio, DatePicker, message, Select, Modal } from 'antd';
import './index.less';
import { API } from '@/http/api';
import http from '@/http';
import moment from "moment";
import Table from "CMPT/common/Table";
const { RangePicker } = DatePicker;
const { Search, TextArea } = Input;

class UserOrder extends Component {

    state = {
        loading: false,
        searchValue: '',
        companyName: '',
        columns: [
            {
                title: "姓名",
                key: "accountName",
                align: "center",
                dataIndex: "accountName",
            },
            {
                title: "手机号码",
                key: "accountPhone",
                align: "center",
                dataIndex: "accountPhone",
            },
            {
                title: "企业名称",
                key: "accountCompanyName",
                align: "center",
                dataIndex: "accountCompanyName",
                render: (text) => {
                    return (
                        <span>{text ? text : "-"}</span>
                    );
                },
            },
            {
                title: "充值时间",
                key: "createDate",
                align: "center",
                dataIndex: "createDate",
                render: (text, record) => {
                    return (
                        <span>{text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"}</span>
                    );
                },
            },
            {
                title: "订单描述",
                key: "description",
                align: "center",
                dataIndex: "description",
            },
            {
                title: "金额",
                key: "payPrice",
                align: "center",
                dataIndex: "payPrice",
            },
            {
                title: "购买次数",
                key: "serviceNumber",
                align: "center",
                dataIndex: "serviceNumber",
            },
            {
                title: "购买凭证",
                key: "payVoucher",
                align: "center",
                dataIndex: "payVoucher",
                render: (text) => {
                    return text ? <div className='img_show_btn' onClick={() => this.imgShow(text)}><span>
                        <i className='iconfont icon-a-tupian1'></i>
                        查看
                    </span></div> : '-';
                },
            },
            {
                title: "状态",
                key: "stateName",
                align: "center",
                dataIndex: "stateName",
            },
        ],
        params: {
            pageSize: 10,
            pageNo: 1,
        },
        addRecordList: [],

    }

    componentDidMount() {
        this.auditList()
    }

    imgShow = (list) => {
        this.setState({
            imgList: list,
            previewVisible: true
        })
    }
    closeImagePreview = () => {
        this.setState({
            previewVisible: false
        })
    }


    auditList = () => {
        let { params } = this.state;
        const config = {
            api: API.payRecords,
            data: params
        };
        http(config).then(res => {
            if (res.code == 200) {
                res.result.total = Number(res.result.total)
                this.setState({
                    addRecordList: res.result,
                })
            }
        })
    }

    rangeChange = (value, date) => {
        let params = this.state.params;
        params.startDate = date[0];
        params.endDate = date[1];
        this.setState({
            params,
            startDate: value[0],
            endDate: value[1]
        }, () => {
            this.auditList();
        })
    }
    searchChange = (e) => {
        this.setState({
            searchValue: e.target.value
        })
    }
    onSearchOn = (e) => {
        let { params } = this.state;
        params.keyword = e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }

    resetSearch = () => {
        let { params } = this.state;
        params.keyword = '';
        params.startDate = '';
        params.endDate = '';
        params.tenantCode = undefined;
        params.queryStatus = undefined;
        params.trackQueryType = undefined;

        this.setState({
            params,
            startDate: undefined,
            endDate: undefined,
            searchValue: '',
            companyName: '',
        }, () => {
            this.auditList()
        })
    }


    //分页
    onChangePage = (pageNo, pageSize, sort) => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    pageNo: pageNo,
                    pageSize: pageSize,
                },
            },
            () => {
                this.auditList();
            }
        );
    };
   

    render() {
        const { searchValue, addRecordList, columns, imgList, startDate, endDate, } = this.state;
        return (
            <div className="enterprise-auth-con-1">
                <div className='tab_box'>

                    <div className='table_box' style={{ paddingTop: '24px' }}>
                        <div className="goods_fliter">
                            <RangePicker value={[startDate, endDate]} onChange={this.rangeChange} style={{ marginRight: '12px' }} />

                            <Search
                                placeholder="姓名/手机号码/企业名称"
                                enterButton="搜索"
                                className="goods_search nomargin"
                                value={searchValue}
                                // size="large"
                                onChange={value => { this.searchChange(value) }}
                                onSearch={value => { this.onSearchOn(value) }}
                            />
                            <span className="goods_reset" onClick={this.resetSearch}>重置</span>
                        </div>
                        <Table
                            columns={columns}
                            selfProcessData={addRecordList && addRecordList.records}
                            total={addRecordList && addRecordList.total}
                            change={this.onChangePage}
                            current={addRecordList && addRecordList.current}
                        />
                        <Modal
                            title=""
                            width='75%'
                            centered={true}
                            visible={this.state.previewVisible}
                            onCancel={this.closeImagePreview}
                            footer={null}
                        >
                            <div>
                                <img src={imgList} style={{ width: '75%' }} />
                            </div>
                        </Modal>


                    </div>
                </div>

            </div>

        );
    }
}

const UserTOrder = Form.create({ name: "UserOrder" })(UserOrder);
export default UserTOrder;